<template>
  <div class="call-user">
    <h1>用户拨打主播列表</h1>
    <div class="header">
      <el-select
        style="width: 160px"
        class="header-item"
        v-model="currentChannel"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          :key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="arrTime"
        align="right"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
        class="header-item"
      >
      </el-date-picker>
      <el-button class="header-item" type="primary" @click="Search"
        >查询</el-button
      >
      <el-button
        class="header-item"
        type="primary"
        @click="DownloadFile"
        :loading="isDownload"
        >下载</el-button
      >
    </div>
    <el-table :data="callUserList" style="width: 100%" v-loading="loading">
      <el-table-column prop="date" label="日期" width="180"> </el-table-column>
      <el-table-column prop="channel" label="平台" width="180">
      </el-table-column>
      <el-table-column prop="name" label="主播名称" width="180">
      </el-table-column>
      <el-table-column prop="modelName" label="主播机型" width="180">
      </el-table-column>
      <el-table-column prop="agentId" label="代理ID" width="180">
      </el-table-column>
      <el-table-column prop="rid" label="主播ID" width="180"> </el-table-column>
      <el-table-column prop="level" label="主播评级" width="180">
      </el-table-column>
      <el-table-column label="是否新主播" width="180">
        <template slot-scope="scope">
          {{ scope.row.newHost ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column prop="area" label="主播所属地区" width="180">
      </el-table-column>
      <el-table-column prop="country" label="主播所属国家" width="180">
      </el-table-column>
      <el-table-column prop="onlineTime" label="主播在线时长(min)" width="180">
      </el-table-column>
      <el-table-column
        prop="homePageUserCount"
        label="主播首页曝光人数"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="homePageCount"
        label="主播首页曝光次数"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="profilePageExposeUserCount"
        label="主播资料页曝光人数"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="profilePageExposeCount"
        label="主播资料页曝光次数"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="calledUserCount"
        label="主播被拨打人数"
        width="180"
      >
      </el-table-column>
      <el-table-column prop="calledCount" label="主播被拨打次数" width="180">
      </el-table-column>
      <el-table-column
        prop="calledUserGoldGtOneMinUserCount"
        label="余额大于1分钟拨打人数"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="calledUserGoldGtOneMinCount"
        label="余额大于1分钟拨打次数"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="calledUserGoldGtOneMinOkUserCount"
        label="余额大于1分钟拨打成功人数"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="calledUserGoldGtOneMinOkCount"
        label="余额大于1分钟拨打成功次数"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="calledUserGoldGtOneMinOkRate"
        label="余额大于1分钟拨打次数成功率"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="noBackCount"
        label="后台弹不出界面次数"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="calledFromNewUserUserCount"
        label="新用户拨打人数"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="calledFromNewUserCount"
        label="新用户拨打次数"
        width="180"
      >
      </el-table-column>
      <el-table-column prop="callingTime" label="主播通话时长(min)" width="180">
      </el-table-column>
      <el-table-column
        prop="callSuccessPeoples"
        label="成功通话人数"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="callSuccessCounts"
        label="成功通话次数"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="calledTime"
        label="用户拨打主播时长(min)"
        width="180"
      >
      </el-table-column>
      <el-table-column prop="calledGold" label="用户拨打主播金币数" width="180">
      </el-table-column>
      <el-table-column
        prop="calledGiftGold"
        label="用户拨打主播礼物金币数"
        width="180"
      >
      </el-table-column>
      <el-table-column prop="gainGold" label="主播获得金币" width="180">
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page.sync="currentPage"
      layout="total, prev, pager, next"
      background
      @current-change="handleCurrentChange"
      :total="total"
      class="pagination"
    ></el-pagination>
  </div>
</template>

<script>
import { downloadFile } from '@/utils/downloadFile.js'
import { datainfor } from '@/utils/formdata.js'

export default {
  data() {
    return {
      arrTime: datainfor(1),
      currentPage: 1,
      total: 0,
      currentChannel: 'total',
      loading: true,
      isDownload: false,
      channels: this.$store.state.channels,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      callUserList: []
    }
  },
  mounted() {
    this.renderList()
  },
  methods: {
    Search() {
      this.renderList()
    },
    DownloadFile() {
      this.isDownload = true
      this.$axios({
        method: 'GET',
        url: this.$store.getters.path.download_call_user_report,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          start: this.arrTime,
          channel: this.currentChannel,
          page: this.currentPage,
          username: this.$store.getters.username,
          token: this.$store.getters.token
        }
      }).then(res => {
        this.$message.success('开始下载')
        this.isDownload = false
        downloadFile(res.data, '用户拨打主播通话数据报表')
      })
    },
    handleCurrentChange() {
      this.renderList()
    },
    renderList() {
      this.loading = true
      this.$axios({
        method: 'GET',
        url: this.$store.getters.path.call_user,
        withCredentials: true,
        params: {
          start: this.arrTime,
          channel: this.currentChannel,
          page: this.currentPage,
          username: this.$store.getters.username,
          token: this.$store.getters.token
        }
      }).then(res => {
        this.loading = false
        if (res.data.code != 0) return this.$message(res.data.data.msg)
        this.callUserList = res.data.data.data
        this.total = res.data.data.total
      })
    }
  }
}
</script>

<style  scoped>
.call-user {
  margin-top: 20px;
  margin-left: 20px;
}
h1 {
  margin-bottom: 20px;
  font-size: 28px;
  font-weight: bold;
}
.header-item {
  margin: 0 5px;
}
.pagination {
  width: 50%;
  margin: 10px auto;
}
</style>
